import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ListIcon, PlusIcon, SearchIcon, SlidersIcon, CalendarIcon, TagIcon, CheckCircleIcon, XCircleIcon, ClockIcon, FileTextIcon, DownloadIcon, BarChart2Icon, UsersIcon, BuildingIcon, UserIcon, StarIcon, ArrowUpDownIcon, BellIcon, MoreHorizontalIcon, InfoIcon, FilterIcon, ChevronDownIcon, MoveUpRightIcon, BookmarkIcon, EyeIcon, LayoutGridIcon, TableIcon, KanbanIcon, ArrowRightIcon, TrendingUpIcon, TrendingDownIcon, DollarSignIcon, RefreshCwIcon, SaveIcon, SunIcon, MoonIcon, CircleIcon, XIcon, GaugeIcon, FolderIcon, MailIcon, PhoneIcon, SendIcon, HeartIcon, BookOpenIcon, AlarmClockIcon, ShieldIcon, ShoppingCartIcon, PaletteIcon, ZapIcon, CheckIcon, PieChartIcon, BarChart4Icon, LayoutDashboardIcon, ChevronRightIcon, ArrowDownIcon, ArrowUpIcon, SlidersHorizontalIcon, SettingsIcon, ClipboardIcon, HelpCircleIcon, PencilIcon, FileIcon, PrinterIcon, ExternalLinkIcon, AlertCircleIcon, ThumbsUpIcon, ThumbsDownIcon, LightbulbIcon, AwardIcon, GlobeIcon, MapPinIcon, UsersIcon as TeamIcon } from 'lucide-react';
import { QuoteScoreModal } from '../components/quotes/QuoteScoreModal';
import { BusinessUnitUserModal } from '../components/quotes/BusinessUnitUserModal';
// Business Unit Users data
const businessUnitUsers = [{
  id: 1,
  name: 'John Smith',
  email: 'john.smith@aisco.com',
  role: 'Regional Manager',
  businessUnit: 'Aisco AMERICA',
  regions: ['North America', 'Latin America'],
  countries: ['USA', 'Canada', 'Mexico', 'Brazil'],
  dealers: ['American Irrigation Co.', 'Canadian Farm Supply', 'Mexico Agrícola']
}, {
  id: 2,
  name: 'Maria Rodriguez',
  email: 'maria.rodriguez@aisco.com',
  role: 'Regional Manager',
  businessUnit: 'Aisco EUROPE',
  regions: ['Western Europe', 'Eastern Europe'],
  countries: ['Spain', 'France', 'Italy', 'Germany', 'Poland'],
  dealers: ['European Irrigation Systems', 'Spanish Agro', 'French Farm Tech']
}, {
  id: 3,
  name: 'Sarah Johnson',
  email: 'sarah.johnson@aisco.com',
  role: 'Regional Manager',
  businessUnit: 'Aisco ANZ',
  regions: ['Australia', 'New Zealand', 'Pacific Islands'],
  countries: ['Australia', 'New Zealand', 'Fiji'],
  dealers: ['Australian Farm Equipment', 'NZ Irrigation Ltd', 'Pacific Agro']
}, {
  id: 4,
  name: 'Michael Brown',
  email: 'michael.brown@aisco.com',
  role: 'Regional Manager',
  businessUnit: 'Aisco AFRICA',
  regions: ['Southern Africa', 'Eastern Africa', 'Western Africa'],
  countries: ['South Africa', 'Kenya', 'Nigeria', 'Egypt'],
  dealers: ['African Irrigation Solutions', 'Kenya Farm Tech', 'Nigeria Agro']
}, {
  id: 5,
  name: 'Wei Zhang',
  email: 'wei.zhang@aisco.com',
  role: 'Regional Manager',
  businessUnit: 'Aisco ASIA',
  regions: ['East Asia', 'Southeast Asia', 'South Asia'],
  countries: ['China', 'Japan', 'India', 'Thailand', 'Vietnam'],
  dealers: ['China Irrigation Systems', 'Japan Agro Tech', 'India Farm Solutions']
}];
export function QuotesPage({
  onNewQuote,
  onViewQuote,
  onToggleSidebar
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState('list'); // 'list', 'grid', 'kanban'
  const [quickFilterActive, setQuickFilterActive] = useState('all');
  const [dateRange, setDateRange] = useState('all');
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [darkMode, setDarkMode] = useState(true);
  const [favoriteQuotes, setFavoriteQuotes] = useState([]);
  const [showSummaryCards, setShowSummaryCards] = useState(true);
  const [sortOption, setSortOption] = useState('date');
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [showScoreModal, setShowScoreModal] = useState(false);
  const [selectedScore, setSelectedScore] = useState(null);
  const [selectedBusinessUnitUser, setSelectedBusinessUnitUser] = useState(null);
  const [showUserModal, setShowUserModal] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    status: 'all',
    businessUnitUser: null,
    quoteType: 'all',
    dateRange: 'all',
    region: 'all',
    country: 'all'
  });
  const [notifications, setNotifications] = useState([{
    id: 1,
    title: 'Quote #QT-5872 is expiring soon',
    description: 'The quote will expire in 3 days',
    time: '2 hours ago',
    read: false,
    type: 'warning'
  }, {
    id: 2,
    title: 'Quote #QT-5869 was approved',
    description: 'Quote was approved by Sarah Johnson',
    time: 'Yesterday',
    read: false,
    type: 'success'
  }, {
    id: 3,
    title: 'New quote template available',
    description: 'Check out the new Pivot System template',
    time: '2 days ago',
    read: true,
    type: 'info'
  }]);
  // Toggle filter panel and close main sidebar when opening
  const toggleFilterPanel = () => {
    const newState = !showFilterPanel;
    setShowFilterPanel(newState);
    // If opening the filter panel, close the main sidebar
    if (newState && onToggleSidebar) {
      onToggleSidebar(true); // Pass true to indicate we want to collapse the sidebar
    }
  };
  // Lista de cotizaciones para usar en ambas vistas
  const quotesList = [{
    id: 'QT-5875',
    title: '8" Valley Pivot System with Corner Arm',
    customer: 'John Doe',
    company: 'Farmland Enterprises',
    date: '3 days ago',
    expiresIn: '27 days',
    status: 'active',
    amount: '$24,599.00',
    tags: ['Pivot', 'Corner'],
    score: 92,
    businessUnitUser: 'John Smith',
    region: 'North America',
    country: 'USA'
  }, {
    id: 'QT-5874',
    title: 'Linear System L200 with Generator',
    customer: 'Sarah Johnson',
    company: 'Green Valley Farms',
    date: '4 days ago',
    expiresIn: '25 days',
    status: 'active',
    amount: '$31,850.00',
    tags: ['Linear'],
    score: 87,
    businessUnitUser: 'John Smith',
    region: 'North America',
    country: 'Canada'
  }, {
    id: 'QT-5873',
    title: 'Replacement Parts Package - Valley',
    customer: 'Michael Smith',
    company: 'Sunset Agriculture',
    date: '5 days ago',
    expiresIn: '20 days',
    status: 'pending',
    amount: '$5,420.00',
    tags: ['Parts', 'Service'],
    score: 64,
    businessUnitUser: 'Maria Rodriguez',
    region: 'Western Europe',
    country: 'Spain'
  }, {
    id: 'QT-5872',
    title: '10" Center Pivot System',
    customer: 'Robert Brown',
    company: 'Harvest Fields Inc.',
    date: '1 week ago',
    expiresIn: '3 days',
    status: 'expiring',
    amount: '$42,780.00',
    tags: ['Pivot'],
    score: 78,
    businessUnitUser: 'Maria Rodriguez',
    region: 'Western Europe',
    country: 'France'
  }, {
    id: 'QT-5871',
    title: 'Sprinkler Package Upgrade',
    customer: 'Emma Davis',
    company: 'Davis Family Farms',
    date: '1 week ago',
    expiresIn: '18 days',
    status: 'active',
    amount: '$8,350.00',
    tags: ['Sprinkler', 'Accessories'],
    score: 81,
    businessUnitUser: 'Sarah Johnson',
    region: 'Australia',
    country: 'Australia'
  }, {
    id: 'QT-5870',
    title: 'Warranty Extension - 5 Years',
    customer: 'James Wilson',
    company: 'Wilson Agro Ltd.',
    date: '2 weeks ago',
    expiresIn: '10 days',
    status: 'pending',
    amount: '$3,200.00',
    tags: ['Warranty', 'Service'],
    score: 59,
    businessUnitUser: 'Sarah Johnson',
    region: 'New Zealand',
    country: 'New Zealand'
  }, {
    id: 'QT-5869',
    title: 'Complete Irrigation Solution',
    customer: 'Jennifer Miller',
    company: 'Miller Farming Co.',
    date: '2 weeks ago',
    expiresIn: 'Approved',
    status: 'approved',
    amount: '$78,500.00',
    tags: ['Pivot', 'Linear', 'Accessories'],
    score: 95,
    businessUnitUser: 'Michael Brown',
    region: 'Southern Africa',
    country: 'South Africa'
  }, {
    id: 'QT-5868',
    title: 'Remote Control System Upgrade',
    customer: 'Daniel Taylor',
    company: 'Taylor Irrigation Services',
    date: '3 weeks ago',
    expiresIn: 'Expired',
    status: 'expired',
    amount: '$12,450.00',
    tags: ['Accessories', 'Service'],
    score: 42,
    businessUnitUser: 'Wei Zhang',
    region: 'East Asia',
    country: 'China'
  }];
  // Count active filters
  const activeFilterCount = Object.values(appliedFilters).filter(value => value !== 'all' && value !== null && value !== undefined).length;
  // Initialize tags from quotes
  useEffect(() => {
    setTags([{
      id: 1,
      name: 'Pivot',
      color: 'blue'
    }, {
      id: 2,
      name: 'Linear',
      color: 'green'
    }, {
      id: 3,
      name: 'Sprinkler',
      color: 'purple'
    }, {
      id: 4,
      name: 'Accessories',
      color: 'amber'
    }, {
      id: 5,
      name: 'Parts',
      color: 'rose'
    }, {
      id: 6,
      name: 'Service',
      color: 'teal'
    }, {
      id: 7,
      name: 'Warranty',
      color: 'indigo'
    }, {
      id: 8,
      name: 'Corner',
      color: 'blue'
    }]);
  }, []);
  // Handle search input change
  const handleSearchChange = e => {
    setSearchQuery(e.target.value);
  };
  // Toggle favorite status for a quote
  const toggleFavorite = quoteId => {
    if (favoriteQuotes.includes(quoteId)) {
      setFavoriteQuotes(favoriteQuotes.filter(id => id !== quoteId));
    } else {
      setFavoriteQuotes([...favoriteQuotes, quoteId]);
    }
  };
  // Mark all notifications as read
  const markAllAsRead = () => {
    setNotifications(notifications.map(n => ({
      ...n,
      read: true
    })));
  };
  // Apply a filter
  const applyFilter = (filterType, value) => {
    setAppliedFilters({
      ...appliedFilters,
      [filterType]: value
    });
    // If selecting a business unit user, find the user details
    if (filterType === 'businessUnitUser' && value !== 'all') {
      const user = businessUnitUsers.find(u => u.name === value);
      setSelectedBusinessUnitUser(user);
    } else if (filterType === 'businessUnitUser' && value === 'all') {
      setSelectedBusinessUnitUser(null);
    }
  };
  // Remove a specific filter
  const removeFilter = filterType => {
    const newFilters = {
      ...appliedFilters
    };
    newFilters[filterType] = filterType === 'businessUnitUser' ? null : 'all';
    setAppliedFilters(newFilters);
    if (filterType === 'businessUnitUser') {
      setSelectedBusinessUnitUser(null);
    }
  };
  // Reset all filters
  const resetAllFilters = () => {
    setAppliedFilters({
      status: 'all',
      businessUnitUser: null,
      quoteType: 'all',
      dateRange: 'all',
      region: 'all',
      country: 'all'
    });
    setSelectedBusinessUnitUser(null);
  };
  // Open user details modal
  const openUserModal = () => {
    if (selectedBusinessUnitUser) {
      setShowUserModal(true);
    }
  };
  // Get color for tag
  const getTagColor = color => {
    const colors = {
      blue: {
        bg: 'bg-blue-100 dark:bg-blue-900/40',
        text: 'text-blue-800 dark:text-blue-300',
        border: 'border-blue-200 dark:border-blue-800'
      },
      green: {
        bg: 'bg-green-100 dark:bg-green-900/40',
        text: 'text-green-800 dark:text-green-300',
        border: 'border-green-200 dark:border-green-800'
      },
      purple: {
        bg: 'bg-purple-100 dark:bg-purple-900/40',
        text: 'text-purple-800 dark:text-purple-300',
        border: 'border-purple-200 dark:border-purple-800'
      },
      amber: {
        bg: 'bg-amber-100 dark:bg-amber-900/40',
        text: 'text-amber-800 dark:text-amber-300',
        border: 'border-amber-200 dark:border-amber-800'
      },
      rose: {
        bg: 'bg-rose-100 dark:bg-rose-900/40',
        text: 'text-rose-800 dark:text-rose-300',
        border: 'border-rose-200 dark:border-rose-800'
      },
      teal: {
        bg: 'bg-teal-100 dark:bg-teal-900/40',
        text: 'text-teal-800 dark:text-teal-300',
        border: 'border-teal-200 dark:border-teal-800'
      },
      indigo: {
        bg: 'bg-indigo-100 dark:bg-indigo-900/40',
        text: 'text-indigo-800 dark:text-indigo-300',
        border: 'border-indigo-200 dark:border-indigo-800'
      },
      gray: {
        bg: 'bg-gray-100 dark:bg-gray-900/40',
        text: 'text-gray-800 dark:text-gray-300',
        border: 'border-gray-200 dark:border-gray-800'
      }
    };
    return colors[color] || colors.gray;
  };
  // Get status badge style
  const getStatusBadge = status => {
    const styles = {
      active: {
        bg: 'bg-green-100 dark:bg-green-900/40',
        text: 'text-green-800 dark:text-green-300',
        icon: <CheckCircleIcon size={14} className="mr-1" data-id="element-11575" data-mp="6pump0n56a27" />
      },
      pending: {
        bg: 'bg-amber-100 dark:bg-amber-900/40',
        text: 'text-amber-800 dark:text-amber-300',
        icon: <ClockIcon size={14} className="mr-1" data-id="element-11576" data-mp="fqsl93et9pde" />
      },
      expired: {
        bg: 'bg-red-100 dark:bg-red-900/40',
        text: 'text-red-800 dark:text-red-300',
        icon: <XCircleIcon size={14} className="mr-1" data-id="element-11577" data-mp="206qm2hqmz31i" />
      },
      expiring: {
        bg: 'bg-amber-100 dark:bg-amber-900/40',
        text: 'text-amber-800 dark:text-amber-300',
        icon: <ClockIcon size={14} className="mr-1" data-id="element-11578" data-mp="1r8ookc642siz" />
      },
      draft: {
        bg: 'bg-gray-100 dark:bg-gray-900/40',
        text: 'text-gray-800 dark:text-gray-300',
        icon: <FileTextIcon size={14} className="mr-1" data-id="element-11579" data-mp="2jvsnbzem2amb" />
      },
      approved: {
        bg: 'bg-blue-100 dark:bg-blue-900/40',
        text: 'text-blue-800 dark:text-blue-300',
        icon: <CheckCircleIcon size={14} className="mr-1" data-id="element-11580" data-mp="2a6hgkjf75i1l" />
      },
      won: {
        bg: 'bg-blue-100 dark:bg-blue-900/40',
        text: 'text-blue-800 dark:text-blue-300',
        icon: <CheckCircleIcon size={14} className="mr-1" data-id="element-11581" data-mp="32nbri9kdfupx" />
      },
      lost: {
        bg: 'bg-gray-100 dark:bg-gray-900/40',
        text: 'text-gray-800 dark:text-gray-300',
        icon: <XCircleIcon size={14} className="mr-1" data-id="element-11582" data-mp="2xuin5msteoed" />
      }
    };
    return styles[status] || styles.pending;
  };
  // Get score color
  const getScoreColor = score => {
    if (score >= 90) return 'text-green-500';
    if (score >= 70) return 'text-blue-500';
    if (score >= 50) return 'text-amber-500';
    return 'text-red-500';
  };
  // Get score background color
  const getScoreBgColor = score => {
    if (score >= 90) return 'bg-green-100 dark:bg-green-900/30';
    if (score >= 70) return 'bg-blue-100 dark:bg-blue-900/30';
    if (score >= 50) return 'bg-amber-100 dark:bg-amber-900/30';
    return 'bg-red-100 dark:bg-red-900/30';
  };
  // Open score modal
  const openScoreModal = (quoteId, event) => {
    if (event) {
      event.stopPropagation();
    }
    const selectedQuote = quotesList.find(q => q.id === quoteId);
    setSelectedScore(quoteId);
    setShowScoreModal(true);
  };
  // Filter quotes based on quick filter selection and applied filters
  const getFilteredQuotes = () => {
    let filtered = quotesList;
    // Apply quick filters
    if (quickFilterActive === 'my-quotes') {
      filtered = filtered.filter(q => q.quotedBy === 'Daniel Alejandro');
    } else if (quickFilterActive === 'dealer-quotes') {
      filtered = filtered.filter(q => q.company && q.company.includes('Ltd'));
    } else if (quickFilterActive === 'expiring-soon') {
      filtered = filtered.filter(q => q.status === 'expiring');
    } else if (quickFilterActive === 'expired') {
      filtered = filtered.filter(q => q.status === 'expired');
    } else if (quickFilterActive === 'won-lost') {
      filtered = filtered.filter(q => q.status === 'approved' || q.status === 'lost');
    }
    // Apply advanced filters
    if (appliedFilters.status !== 'all') {
      filtered = filtered.filter(q => q.status === appliedFilters.status);
    }
    if (appliedFilters.businessUnitUser) {
      filtered = filtered.filter(q => q.businessUnitUser === appliedFilters.businessUnitUser);
    }
    if (appliedFilters.quoteType !== 'all') {
      filtered = filtered.filter(q => q.tags.includes(appliedFilters.quoteType));
    }
    if (appliedFilters.region !== 'all') {
      filtered = filtered.filter(q => q.region === appliedFilters.region);
    }
    if (appliedFilters.country !== 'all') {
      filtered = filtered.filter(q => q.country === appliedFilters.country);
    }
    // Apply search query
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(q => q.id.toLowerCase().includes(query) || q.title.toLowerCase().includes(query) || q.customer.toLowerCase().includes(query) || q.company.toLowerCase().includes(query));
    }
    return filtered;
  };
  const filteredQuotes = getFilteredQuotes();
  // Statistics for summary cards
  const quoteStats = {
    total: quotesList.length,
    active: quotesList.filter(q => q.status === 'active').length,
    pending: quotesList.filter(q => q.status === 'pending').length,
    expiring: quotesList.filter(q => q.status === 'expiring').length,
    expired: quotesList.filter(q => q.status === 'expired').length,
    approved: quotesList.filter(q => q.status === 'approved').length,
    totalValue: quotesList.reduce((sum, quote) => sum + parseFloat(quote.amount.replace(/[^0-9.-]+/g, '')), 0)
  };
  return <div className="flex flex-col h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-11583" data-mp="3oubbj17flcwr">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-11584" data-mp="3fs20ma893hiu">
        <div className="absolute top-[10%] left-[5%] w-64 h-64 bg-blue-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-11585" data-mp="3b0sdphe36san"></div>
        <div className="absolute top-[40%] right-[10%] w-72 h-72 bg-purple-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-11586" data-mp="3628qldnrbagp"></div>
        <div className="absolute bottom-[10%] left-[25%] w-80 h-80 bg-teal-600 rounded-full mix-blend-multiply filter blur-[100px] opacity-20" data-id="element-11587" data-mp="2x1sp29qkqdeh"></div>
      </div>
      {/* Header */}
      <div className="bg-white/5 backdrop-blur-sm border-b border-white/10 px-6 py-4 relative z-10" data-id="element-11588" data-mp="jthz54uazk0y">
        <div className="flex justify-between items-center" data-id="element-11589" data-mp="oscj4a40bemn">
          <div className="flex items-center" data-id="element-11590" data-mp="ortbpnbzg8mv">
            <h1 className="text-xl font-bold text-white flex items-center" data-id="element-11591" data-mp="atcuh2ghuzqh">
              <FileTextIcon size={24} className="mr-2 text-blue-400" data-id="element-11592" data-mp="av65ety5464a" />
              Quote Management
            </h1>
          </div>
          <div className="flex items-center space-x-3" data-id="element-11593" data-mp="12qjjljq2xe4">
            <div className="relative" data-id="element-11594" data-mp="11739uy2gmcc">
              <button className="p-2 text-blue-300 hover:text-white hover:bg-white/10 rounded-full relative" onClick={() => setShowNotifications(!showNotifications)} data-id="element-11595" data-mp="5u07mhpmhsnw">
                <BellIcon size={20} data-id="element-11596" data-mp="3s9b6at2qvj5c" />
                {notifications.filter(n => !n.read).length > 0 && <span className="absolute top-0 right-0 w-4 h-4 bg-red-500 text-white text-xs flex items-center justify-center rounded-full" data-id="element-11597" data-mp="3s6yrgosa9owi">
                    {notifications.filter(n => !n.read).length}
                  </span>}
              </button>
              {showNotifications && <div className="absolute right-0 mt-2 w-80 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg shadow-lg border border-white/10 z-10" data-id="element-11598" data-mp="2znd2opxka2bc">
                  <div className="p-3 border-b border-white/10 flex justify-between items-center" data-id="element-11599" data-mp="38nrpxuu35rhh">
                    <h3 className="font-semibold text-white" data-id="element-11600" data-mp="34kv4lwd5vh9u">Notifications</h3>
                    <button className="text-sm text-blue-400 hover:text-blue-300" onClick={markAllAsRead} data-id="element-11601" data-mp="3il5wn2q7j1wl">
                      Mark all as read
                    </button>
                  </div>
                  <div className="max-h-80 overflow-y-auto" data-id="element-11602" data-mp="3sb8wnmvqxg4f">
                    {notifications.length === 0 ? <div className="p-4 text-center text-slate-400" data-id="element-11603" data-mp="3ncnyru3yv8j5">
                        No notifications
                      </div> : notifications.map(notification => {
                  const getTypeStyles = type => {
                    switch (type) {
                      case 'warning':
                        return 'text-amber-400 bg-amber-900/40 border-amber-700/50';
                      case 'success':
                        return 'text-green-400 bg-green-900/40 border-green-700/50';
                      case 'info':
                        return 'text-blue-400 bg-blue-900/40 border-blue-700/50';
                      default:
                        return 'text-blue-400 bg-blue-900/40 border-blue-700/50';
                    }
                  };
                  return <div key={notification.id} className={`p-3 border-b border-white/10 hover:bg-white/5 ${!notification.read ? 'bg-white/5' : ''}`} data-id="element-11604" data-mp="3q2zz5bx7jihp">
                            <div className="flex" data-id="element-11605" data-mp="3qjhei3w4uox">
                              <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${getTypeStyles(notification.type)} border`} data-id="element-11606" data-mp="3v4p90o8p1q47">
                                {notification.type === 'warning' && <ClockIcon size={16} data-id="element-11607" data-mp="32frqql4hftbg" />}
                                {notification.type === 'success' && <CheckCircleIcon size={16} data-id="element-11608" data-mp="32dxfjyj0jfkk" />}
                                {notification.type === 'info' && <InfoIcon size={16} data-id="element-11609" data-mp="1hvmpdlz3op9d" />}
                              </div>
                              <div data-id="element-11610" data-mp="1mqiqrcq88oz5">
                                <h4 className="font-medium text-white" data-id="element-11611" data-mp="18xavnb2xtbcp">
                                  {notification.title}
                                </h4>
                                <p className="text-sm text-blue-200" data-id="element-11612" data-mp="1cwjs4npd3nby">
                                  {notification.description}
                                </p>
                                <div className="text-xs text-blue-300 mt-1" data-id="element-11613" data-mp="25m0h1bdrwm3f">
                                  {notification.time}
                                </div>
                              </div>
                            </div>
                          </div>;
                })}
                  </div>
                  <div className="p-3 border-t border-white/10 text-center" data-id="element-11614" data-mp="g7kf6vdu1xdf">
                    <button className="text-sm text-blue-400 hover:text-blue-300" data-id="element-11615" data-mp="l7qcos6sae3f">
                      View all notifications
                    </button>
                  </div>
                </div>}
            </div>
            <button className="p-2 text-blue-300 hover:text-white hover:bg-white/10 rounded-full" onClick={() => setDarkMode(!darkMode)} data-id="element-11616" data-mp="2hyudi1mc3ucw">
              {darkMode ? <SunIcon size={20} data-id="element-11617" data-mp="2957meot2nfa1" /> : <MoonIcon size={20} data-id="element-11618" data-mp="2960x20v5ioxg" />}
            </button>
            <div className="relative" data-id="element-11619" data-mp="2934we4rx5m5b">
              <button className="flex items-center space-x-2 hover:bg-white/10 py-1.5 px-2 rounded-lg" onClick={() => setShowUserMenu(!showUserMenu)} data-id="element-11620" data-mp="246ek7sj8jap6">
                <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 text-white rounded-full flex items-center justify-center font-medium" data-id="element-11621" data-mp="1z94ltndvbop7">
                  JD
                </div>
                <span className="text-white font-medium hidden md:block" data-id="element-11622" data-mp="1q8g8yw07nudw">
                  John Doe
                </span>
                <ChevronDownIcon size={16} className="text-blue-300 hidden md:block" data-id="element-11623" data-mp="3kkeeonzba851" />
              </button>
              {showUserMenu && <div className="absolute right-0 mt-2 w-56 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg shadow-lg border border-white/10 z-10" data-id="element-11624" data-mp="16dewgkqmbitt">
                  <div className="p-3 border-b border-white/10" data-id="element-11625" data-mp="1g2f0wjnw36fe">
                    <div className="font-medium text-white" data-id="element-11626" data-mp="1g386hhb43pvy">John Doe</div>
                    <div className="text-sm text-blue-300" data-id="element-11627" data-mp="1k2qghi1eagk0">
                      john.doe@example.com
                    </div>
                  </div>
                  <div className="py-1" data-id="element-11628" data-mp="scue1pom7p0u">
                    <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-11629" data-mp="sdvopt1py9i1">
                      <UserIcon size={16} className="mr-2 text-blue-400" data-id="element-11630" data-mp="wdo3wolmbdwd" />
                      My Profile
                    </button>
                    <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-11631" data-mp="11b61xjy3k8pl">
                      <SettingsIcon size={16} className="mr-2 text-blue-400" data-id="element-11632" data-mp="2cspazsycz5w2" />
                      Settings
                    </button>
                    <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-11633" data-mp="2bcl9qq7089yt">
                      <HelpCircleIcon size={16} className="mr-2 text-blue-400" data-id="element-11634" data-mp="26dqrpqgv2pfr" />
                      Help & Support
                    </button>
                  </div>
                  <div className="py-1 border-t border-white/10" data-id="element-11635" data-mp="2ga3leocep3ai">
                    <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-11636" data-mp="2gcziybkcdpyf">
                      <LogoutIcon size={16} className="mr-2 text-blue-400" data-id="element-11637" data-mp="2pbb623m025m4" />
                      Sign Out
                    </button>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </div>
      {/* Search and filters */}
      <div className="bg-white/5 backdrop-blur-sm border-b border-white/10 px-6 py-4 relative z-10" data-id="element-11638" data-mp="2z1mjqhvhjt67">
        <div className="flex flex-wrap items-center gap-3" data-id="element-11639" data-mp="3d15iik2eps5u">
          <div className="relative flex-1 min-w-[240px]" data-id="element-11640" data-mp="382khwjj8t6gv">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-11641" data-mp="37zyb4m46euzp" />
            <input type="text" placeholder="Search quotes, customers, products..." value={searchQuery} onChange={handleSearchChange} className="w-full bg-white/10 border border-white/20 rounded-lg pl-10 pr-4 py-2.5 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-11642" data-mp="h9wfhpdhpml" />
          </div>
          <div className="flex items-center gap-2" data-id="element-11643" data-mp="38wl480fuuueu">
            <div className="relative" data-id="element-11644" data-mp="38v0a2bxgddhi">
              <select className="appearance-none bg-white/10 border border-white/20 rounded-lg pl-3 pr-10 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" value={dateRange} onChange={e => setDateRange(e.target.value)} data-id="element-11645" data-mp="3dobjmktng8d4">
                <option value="all" data-id="element-11646" data-mp="33yjl5fifiv3d">All Time</option>
                <option value="today" data-id="element-11647" data-mp="2pyh57ytombqr">Today</option>
                <option value="week" data-id="element-11648" data-mp="2pz0r1qmgdka2">This Week</option>
                <option value="month" data-id="element-11649" data-mp="2uxtsulsdnmue">This Month</option>
                <option value="quarter" data-id="element-11650" data-mp="2uzen0aas53rq">This Quarter</option>
                <option value="year" data-id="element-11651" data-mp="10i54xqubmwg8">This Year</option>
              </select>
              <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 text-blue-300 pointer-events-none" size={16} data-id="element-11652" data-mp="vpv8drypay4z" />
            </div>
            <button className={`flex items-center ${activeFilterCount > 0 ? 'bg-blue-600 hover:bg-blue-700' : 'bg-white/10 hover:bg-white/15'} border ${activeFilterCount > 0 ? 'border-blue-500' : 'border-white/20'} rounded-lg px-4 py-2.5 text-white transition-colors relative`} onClick={toggleFilterPanel} data-id="element-11653" data-mp="qp7m1jlf35h3">
              <FilterIcon size={18} className="mr-2" data-id="element-11654" data-mp="1ef1wjui9khy6" />
              Filters
              {activeFilterCount > 0 && <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-11655" data-mp="1ah47qssenxvb">
                  {activeFilterCount}
                </span>}
            </button>
            <button className="flex items-center bg-blue-600 hover:bg-blue-700 text-white rounded-lg px-4 py-2.5 transition-colors" onClick={onNewQuote} data-id="element-11656" data-mp="3q5w4et83mpmi">
              <PlusIcon size={18} className="mr-2" data-id="element-11657" data-mp="25q7owp6diuxr" />
              New Quote
            </button>
          </div>
        </div>
        {/* Applied filters display */}
        {activeFilterCount > 0 && <div className="mt-3 flex flex-wrap gap-2" data-id="element-11658" data-mp="2enruubf6lfep">
            {appliedFilters.status !== 'all' && <div className="bg-blue-900/40 text-blue-300 border border-blue-800/50 rounded-full px-3 py-1 text-sm flex items-center" data-id="element-11659" data-mp="2jhckng6mf32t">
                <span className="mr-2" data-id="element-11660" data-mp="2tdz3jzfdzk27">Status: {appliedFilters.status}</span>
                <button onClick={() => removeFilter('status')} className="text-blue-300 hover:text-white" data-id="element-11661" data-mp="2tc4k6pjrk008">
                  <XIcon size={14} data-id="element-11662" data-mp="2yaxu67zud8vn" />
                </button>
              </div>}
            {appliedFilters.businessUnitUser && <div className="bg-indigo-900/40 text-indigo-300 border border-indigo-800/50 rounded-full px-3 py-1 text-sm flex items-center cursor-pointer" onClick={openUserModal} data-id="element-11663" data-mp="13z116alr3uyh">
                <span className="mr-2" data-id="element-11664" data-mp="182paoyty10md">
                  User: {appliedFilters.businessUnitUser}
                </span>
                <button onClick={e => {
            e.stopPropagation();
            removeFilter('businessUnitUser');
          }} className="text-indigo-300 hover:text-white" data-id="element-11665" data-mp="k5awca8q5bas">
                  <XIcon size={14} data-id="element-11666" data-mp="xysfvv1euo0t" />
                </button>
              </div>}
            {appliedFilters.quoteType !== 'all' && <div className="bg-purple-900/40 text-purple-300 border border-purple-800/50 rounded-full px-3 py-1 text-sm flex items-center" data-id="element-11667" data-mp="65i8cmol196i">
                <span className="mr-2" data-id="element-11668" data-mp="17qf9pc7bh0q">Type: {appliedFilters.quoteType}</span>
                <button onClick={() => removeFilter('quoteType')} className="text-purple-300 hover:text-white" data-id="element-11669" data-mp="f6gcr62xnipm">
                  <XIcon size={14} data-id="element-11670" data-mp="a6217e24hqmu" />
                </button>
              </div>}
            {appliedFilters.region !== 'all' && <div className="bg-green-900/40 text-green-300 border border-green-800/50 rounded-full px-3 py-1 text-sm flex items-center" data-id="element-11671" data-mp="1qjs8etojgv0p">
                <span className="mr-2" data-id="element-11672" data-mp="1u3ake0d0jfc9">Region: {appliedFilters.region}</span>
                <button onClick={() => removeFilter('region')} className="text-green-300 hover:text-white" data-id="element-11673" data-mp="1u1zjc8ayclou">
                  <XIcon size={14} data-id="element-11674" data-mp="1y2rtd3rneum6" />
                </button>
              </div>}
            {appliedFilters.country !== 'all' && <div className="bg-amber-900/40 text-amber-300 border border-amber-800/50 rounded-full px-3 py-1 text-sm flex items-center" data-id="element-11675" data-mp="1p46ebildxxq5">
                <span className="mr-2" data-id="element-11676" data-mp="2cutn0634krdr">Country: {appliedFilters.country}</span>
                <button onClick={() => removeFilter('country')} className="text-amber-300 hover:text-white" data-id="element-11677" data-mp="2htd8649w9z52">
                  <XIcon size={14} data-id="element-11678" data-mp="234qsg1gcv5db" />
                </button>
              </div>}
            <button onClick={resetAllFilters} className="bg-white/10 text-blue-200 border border-white/20 rounded-full px-3 py-1 text-sm hover:bg-white/15" data-id="element-11679" data-mp="282saqk5yj0nq">
              Clear All
            </button>
          </div>}
      </div>
      {/* Main content with sidebar */}
      <div className="flex-1 flex overflow-hidden relative z-10" data-id="element-11680" data-mp="30lfv1xd4qbnr">
        {/* Filter sidebar */}
        <AnimatePresence data-id="element-11681" data-mp="6bveh8etw0i3">
          {showFilterPanel && <motion.div className="w-80 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm border-r border-white/10 overflow-y-auto flex-shrink-0" initial={{
          x: -320
        }} animate={{
          x: 0
        }} exit={{
          x: -320
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} data-id="element-11682" data-mp="bcas8130va0l">
              <div className="p-4 border-b border-white/10 flex justify-between items-center" data-id="element-11683" data-mp="3jmm4evacpnck">
                <h3 className="text-lg font-semibold text-white flex items-center" data-id="element-11684" data-mp="3olowlf58fz34">
                  <FilterIcon size={18} className="mr-2 text-blue-400" data-id="element-11685" data-mp="3th4b89b2dz0l" />
                  Filters
                </h3>
                <button className="text-blue-300 hover:text-white bg-white/10 hover:bg-white/15 rounded-full p-1.5" onClick={() => setShowFilterPanel(false)} data-id="element-11686" data-mp="1cs9fnyulua4">
                  <XIcon size={16} data-id="element-11687" data-mp="1ct0cdqi6z7mb" />
                </button>
              </div>
              <div className="p-4 space-y-6" data-id="element-11688" data-mp="2xcm3zw82utlg">
                {/* Status filter */}
                <div data-id="element-11689" data-mp="2tar2orq5cg7o">
                  <label className="block text-sm font-medium text-blue-200 mb-2" data-id="element-11690" data-mp="2ta8z1a15mzpq">
                    Status
                  </label>
                  <select className="w-full bg-white/10 border border-white/20 rounded-lg pl-3 pr-10 py-2.5 text-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500" value={appliedFilters.status} onChange={e => applyFilter('status', e.target.value)} data-id="element-11691" data-mp="2ohxz476ezdx6">
                    <option value="all" data-id="element-11692" data-mp="29lqdd2fcy4fs">All Statuses</option>
                    <option value="active" data-id="element-11693" data-mp="25kmxwh182af3">Active</option>
                    <option value="pending" data-id="element-11694" data-mp="25l6i64echawa">Pending</option>
                    <option value="expiring" data-id="element-11695" data-mp="20mlge0jg2j5q">Expiring Soon</option>
                    <option value="expired" data-id="element-11696" data-mp="3tjm3oflipsy">Expired</option>
                    <option value="approved" data-id="element-11697" data-mp="3t1i25moz7ah">Approved</option>
                    <option value="lost" data-id="element-11698" data-mp="3uzbc8ntdi2fr">Lost</option>
                  </select>
                </div>
                {/* Business Unit User filter */}
                <div data-id="element-11699" data-mp="hxsdn3drmt6c">
                  <label className="block text-sm font-medium text-blue-200 mb-2" data-id="element-11700" data-mp="mps6yczbynty">
                    Business Unit User
                  </label>
                  <select className="w-full bg-white/10 border border-white/20 rounded-lg pl-3 pr-10 py-2.5 text-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500" value={appliedFilters.businessUnitUser || ''} onChange={e => applyFilter('businessUnitUser', e.target.value === 'all' ? null : e.target.value)} data-id="element-11701" data-mp="8zorc4uyhsdh">
                    <option value="all" data-id="element-11702" data-mp="15mjx96dai37i">All Users</option>
                    {businessUnitUsers.map(user => <option key={user.id} value={user.name} data-id="element-11703" data-mp="ron1gc6nu0tw">
                        {user.name} - {user.businessUnit}
                      </option>)}
                  </select>
                </div>
                {/* Quote Type filter */}
                <div data-id="element-11704" data-mp="3hdxg11ucxz0d">
                  <label className="block text-sm font-medium text-blue-200 mb-2" data-id="element-11705" data-mp="3hf8garolgomq">
                    Quote Type
                  </label>
                  <select className="w-full bg-white/10 border border-white/20 rounded-lg pl-3 pr-10 py-2.5 text-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500" value={appliedFilters.quoteType} onChange={e => applyFilter('quoteType', e.target.value)} data-id="element-11706" data-mp="39wsiccpzs3m5">
                    <option value="all" data-id="element-11707" data-mp="3dwsvzv59oas5">All Types</option>
                    {tags.map(tag => <option key={tag.id} value={tag.name} data-id="element-11708" data-mp="2q5x4kz4q3hlf">
                        {tag.name}
                      </option>)}
                  </select>
                </div>
                {/* Region filter */}
                <div data-id="element-11709" data-mp="2zxa0c1tn6rwq">
                  <label className="block text-sm font-medium text-blue-200 mb-2" data-id="element-11710" data-mp="2zxt6ymdudtvg">
                    Region
                  </label>
                  <select className="w-full bg-white/10 border border-white/20 rounded-lg pl-3 pr-10 py-2.5 text-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500" value={appliedFilters.region} onChange={e => applyFilter('region', e.target.value)} data-id="element-11711" data-mp="27fxm4v3e10qz">
                    <option value="all" data-id="element-11712" data-mp="2g1qkhhvooi1k">All Regions</option>
                    {/* Get unique regions from quotes */}
                    {[...new Set(quotesList.map(q => q.region))].map(region => <option key={region} value={region} data-id="element-11713" data-mp="2q0g3xf38aajx">
                          {region}
                        </option>)}
                  </select>
                </div>
                {/* Country filter */}
                <div data-id="element-11714" data-mp="2ywf9gv31ihv3">
                  <label className="block text-sm font-medium text-blue-200 mb-2" data-id="element-11715" data-mp="33tfdl0gbxajk">
                    Country
                  </label>
                  <select className="w-full bg-white/10 border border-white/20 rounded-lg pl-3 pr-10 py-2.5 text-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500" value={appliedFilters.country} onChange={e => applyFilter('country', e.target.value)} data-id="element-11716" data-mp="38tjxl0gg4nej">
                    <option value="all" data-id="element-11717" data-mp="1jd2ddgliaf6x">All Countries</option>
                    {/* Get unique countries from quotes */}
                    {[...new Set(quotesList.map(q => q.country))].map(country => <option key={country} value={country} data-id="element-11718" data-mp="3rx5cd19efzv1">
                          {country}
                        </option>)}
                  </select>
                </div>
                <div className="pt-4 border-t border-white/10" data-id="element-11719" data-mp="3ntfoke0jtmb2">
                  <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2.5 rounded-lg transition-colors" onClick={() => setShowFilterPanel(false)} data-id="element-11720" data-mp="3ixiayfgo6u1z">
                    Apply Filters
                  </button>
                  <button className="w-full mt-2 bg-white/10 hover:bg-white/15 text-blue-200 py-2.5 rounded-lg transition-colors" onClick={resetAllFilters} data-id="element-11721" data-mp="fgi39fqokler">
                    Reset All Filters
                  </button>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
        {/* Main content area */}
        <div className="flex-1 overflow-auto p-6" data-id="element-11722" data-mp="2q78kr6c2jxzr">
          <div className="space-y-6" data-id="element-11723" data-mp="2q6gp5vih209h">
            {/* Summary cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-11724" data-mp="2rq03jvjxvv5i">
              <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10 p-4" data-id="element-11725" data-mp="2woa28g4vhdvv">
                <div className="flex items-center justify-between mb-3" data-id="element-11726" data-mp="2inzbre7h61b8">
                  <h3 className="text-blue-200 font-medium" data-id="element-11727" data-mp="2nm0svtlcbqk2">Total Quotes</h3>
                  <div className="p-2 bg-blue-900/50 rounded-lg border border-blue-800/50" data-id="element-11728" data-mp="28xxoupquyoxw">
                    <ClipboardIcon size={18} className="text-blue-400" data-id="element-11729" data-mp="2dppff0a0kuo1" />
                  </div>
                </div>
                <div className="text-3xl font-bold text-white mb-1" data-id="element-11730" data-mp="1zysnzcrtqjik">
                  {quoteStats.total}
                </div>
                <div className="text-sm text-blue-300" data-id="element-11731" data-mp="23zw665xcgrmy">
                  <span className="inline-flex items-center text-green-400 mr-1" data-id="element-11732" data-mp="1pz1v1fiwwckl">
                    <TrendingUpIcon size={14} className="mr-1" data-id="element-11733" data-mp="1uyequprrgtzb" />
                    +12%
                  </span>
                  vs previous month
                </div>
              </div>
              <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10 p-4" data-id="element-11734" data-mp="16dt818uf4fjq">
                <div className="flex items-center justify-between mb-3" data-id="element-11735" data-mp="1lc3ovc1hi8cp">
                  <h3 className="text-blue-200 font-medium" data-id="element-11736" data-mp="1gc929koqs4xg">Active Quotes</h3>
                  <div className="p-2 bg-green-900/50 rounded-lg border border-green-800/50" data-id="element-11737" data-mp="1gebwkgwxgk7z">
                    <CheckCircleIcon size={18} className="text-green-400" data-id="element-11738" data-mp="1u9e3969lmdlu" />
                  </div>
                </div>
                <div className="text-3xl font-bold text-white mb-1" data-id="element-11739" data-mp="241abvb9b9m4b">
                  {quoteStats.active}
                </div>
                <div className="text-sm text-blue-300" data-id="element-11740" data-mp="1z3ibrtyiitp1">
                  <span className="inline-flex items-center text-green-400 mr-1" data-id="element-11741" data-mp="2d287b55oolba">
                    <TrendingUpIcon size={14} className="mr-1" data-id="element-11742" data-mp="2d05l6w7njcbu" />
                    +5%
                  </span>
                  vs previous month
                </div>
              </div>
              <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10 p-4" data-id="element-11743" data-mp="3ffcor1p999ui">
                <div className="flex items-center justify-between mb-3" data-id="element-11744" data-mp="3pe1ww2rcnfxk">
                  <h3 className="text-blue-200 font-medium" data-id="element-11745" data-mp="3pbxu5o56smyv">Expiring Soon</h3>
                  <div className="p-2 bg-amber-900/50 rounded-lg border border-amber-800/50" data-id="element-11746" data-mp="3tekopwt8slzr">
                    <ClockIcon size={18} className="text-amber-400" data-id="element-11747" data-mp="2wqo2ocf1cyh5" />
                  </div>
                </div>
                <div className="text-3xl font-bold text-white mb-1" data-id="element-11748" data-mp="31m3ih9wlt4g7">
                  {quoteStats.expiring}
                </div>
                <div className="text-sm text-blue-300" data-id="element-11749" data-mp="3ag9ijdxjgxky">
                  <span className="inline-flex items-center text-amber-400 mr-1" data-id="element-11750" data-mp="3ahsyt4j738mq">
                    <AlertCircleIcon size={14} className="mr-1" data-id="element-11751" data-mp="2dxtx293ayipl" />
                  </span>
                  Require attention
                </div>
              </div>
              <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10 p-4" data-id="element-11752" data-mp="2ah7kywa8kx54">
                <div className="flex items-center justify-between mb-3" data-id="element-11753" data-mp="25i4fxbu9aqx5">
                  <h3 className="text-blue-200 font-medium" data-id="element-11754" data-mp="21eydyge6flwh">Total Value</h3>
                  <div className="p-2 bg-blue-900/50 rounded-lg border border-blue-800/50" data-id="element-11755" data-mp="1wh6ixdi8jjo2">
                    <DollarSignIcon size={18} className="text-blue-400" data-id="element-11756" data-mp="1rhjxwhw60z4p" />
                  </div>
                </div>
                <div className="text-3xl font-bold text-white mb-1" data-id="element-11757" data-mp="1mqv58z8r1w3z">
                  ${quoteStats.totalValue.toLocaleString()}
                </div>
                <div className="text-sm text-blue-300" data-id="element-11758" data-mp="1hpxqyxqv1m7r">
                  <span className="inline-flex items-center text-green-400 mr-1" data-id="element-11759" data-mp="1drghi7jyvzn6">
                    <TrendingUpIcon size={14} className="mr-1" data-id="element-11760" data-mp="18rvglrl8lh7t" />
                    +8.5%
                  </span>
                  vs previous month
                </div>
              </div>
            </div>
            {/* Quick access filters */}
            <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10 p-4" data-id="element-11761" data-mp="bwqg1tf0tduk">
              <div className="flex flex-wrap items-center gap-3" data-id="element-11762" data-mp="25cj9teges54">
                <span onClick={() => setQuickFilterActive('all')} className={`px-3 py-1.5 rounded-full flex items-center text-sm cursor-pointer transition-colors ${quickFilterActive === 'all' ? 'bg-blue-500/70 text-white ring-2 ring-blue-500 ring-opacity-50' : 'bg-white/10 text-blue-200 hover:bg-white/15 border border-white/20'}`} data-id="element-11763" data-mp="23i0olqnnc47">
                  <FileTextIcon size={14} className="mr-1.5" data-id="element-11764" data-mp="kvkk24uol6i5" />
                  All
                </span>
                <span onClick={() => setQuickFilterActive('my-quotes')} className={`px-3 py-1.5 rounded-full flex items-center text-sm cursor-pointer transition-colors ${quickFilterActive === 'my-quotes' ? 'bg-blue-500/70 text-white ring-2 ring-blue-500 ring-opacity-50' : 'bg-white/10 text-blue-200 hover:bg-white/15 border border-white/20'}`} data-id="element-11765" data-mp="fxisevj6vyv2">
                  <UserIcon size={14} className="mr-1.5" data-id="element-11766" data-mp="1g70jygm8ehyp" />
                  My Quotes
                </span>
                <span onClick={() => setQuickFilterActive('dealer-quotes')} className={`px-3 py-1.5 rounded-full flex items-center text-sm cursor-pointer transition-colors ${quickFilterActive === 'dealer-quotes' ? 'bg-blue-500/70 text-white ring-2 ring-blue-500 ring-opacity-50' : 'bg-white/10 text-blue-200 hover:bg-white/15 border border-white/20'}`} data-id="element-11767" data-mp="1l27kxgo498jx">
                  <BuildingIcon size={14} className="mr-1.5" data-id="element-11768" data-mp="23tql7fqra8i9" />
                  My Dealers' Quotes
                </span>
                <span onClick={() => setQuickFilterActive('expiring-soon')} className={`px-3 py-1.5 rounded-full flex items-center text-sm cursor-pointer transition-colors ${quickFilterActive === 'expiring-soon' ? 'bg-amber-500/70 text-white ring-2 ring-amber-500 ring-opacity-50' : 'bg-white/10 text-blue-200 hover:bg-white/15 border border-white/20'}`} data-id="element-11769" data-mp="28ue8bqbv6577">
                  <AlertCircleIcon size={14} className="mr-1.5" data-id="element-11770" data-mp="bdpabmczezpc" />
                  Expiring Soon
                </span>
                <span onClick={() => setQuickFilterActive('expired')} className={`px-3 py-1.5 rounded-full flex items-center text-sm cursor-pointer transition-colors ${quickFilterActive === 'expired' ? 'bg-blue-500/70 text-white ring-2 ring-blue-500 ring-opacity-50' : 'bg-white/10 text-blue-200 hover:bg-white/15 border border-white/20'}`} data-id="element-11771" data-mp="7dowo3xpisjc">
                  <XCircleIcon size={14} className="mr-1.5" data-id="element-11772" data-mp="ub0d3gxtob9j" />
                  Expired
                </span>
                <span onClick={() => setQuickFilterActive('won-lost')} className={`px-3 py-1.5 rounded-full flex items-center text-sm cursor-pointer transition-colors ${quickFilterActive === 'won-lost' ? 'bg-blue-500/70 text-white ring-2 ring-blue-500 ring-opacity-50' : 'bg-white/10 text-blue-200 hover:bg-white/15 border border-white/20'}`} data-id="element-11773" data-mp="q9opti2f824i">
                  <CheckCircleIcon size={14} className="mr-1.5" data-id="element-11774" data-mp="193240bhwztxf" />
                  Won / Lost
                </span>
                <div className="flex items-center ml-auto gap-2" data-id="element-11775" data-mp="1soarejablsyt">
                  <div className="flex bg-white/10 border border-white/20 rounded-lg overflow-hidden p-0.5" data-id="element-11776" data-mp="1wpnxmuhbry69">
                    <button className={`p-1.5 rounded-md ${viewMode === 'list' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:bg-white/10'}`} onClick={() => setViewMode('list')} data-id="element-11777" data-mp="1iojvcd6435wm">
                      <ListIcon size={18} data-id="element-11778" data-mp="18za1osvmdf6e" />
                    </button>
                    <button className={`p-1.5 rounded-md ${viewMode === 'grid' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:bg-white/10'}`} onClick={() => setViewMode('grid')} data-id="element-11779" data-mp="18xz1t45aorkk">
                      <LayoutGridIcon size={18} data-id="element-11780" data-mp="zx0twarqjzwp" />
                    </button>
                    <button className={`p-1.5 rounded-md ${viewMode === 'kanban' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:bg-white/10'}`} onClick={() => setViewMode('kanban')} data-id="element-11781" data-mp="14yq5briveflb">
                      <KanbanIcon size={18} data-id="element-11782" data-mp="uypivwppfjcw" />
                    </button>
                  </div>
                  <div className="relative" data-id="element-11783" data-mp="1y9wq0038umm9">
                    <button className="bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-blue-200 flex items-center" onClick={() => setShowSortMenu(!showSortMenu)} data-id="element-11784" data-mp="1ycr65ff85l9v">
                      <ArrowUpDownIcon size={16} className="text-blue-300 mr-2" data-id="element-11785" data-mp="1ojaeoi2k8i9d" />
                      <span data-id="element-11786" data-mp="1jl8vzy91qkyf">Sort by</span>
                      <ChevronDownIcon size={16} className="text-blue-300 ml-2" data-id="element-11787" data-mp="1jk7fvfd6b89u" />
                    </button>
                    {showSortMenu && <div className="absolute right-0 mt-2 w-48 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg shadow-lg border border-white/10 z-10 py-1" data-id="element-11788" data-mp="1aku7kq0scpqp">
                        <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-11789" data-mp="10nfririry2yx">
                          <CalendarIcon size={14} className="mr-2 text-blue-300" data-id="element-11790" data-mp="300tlslj9h5d7" />
                          Most recent
                        </button>
                        <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-11791" data-mp="2v20bf1z9tuh9">
                          <CalendarIcon size={14} className="mr-2 text-blue-300" data-id="element-11792" data-mp="32ivo6hxg88wn" />
                          Oldest first
                        </button>
                        <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-11793" data-mp="3cbkn6dbtbub3">
                          <ArrowUpIcon size={14} className="mr-2 text-blue-300" data-id="element-11794" data-mp="3h92xa71kgfko" />
                          Highest value
                        </button>
                        <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-11795" data-mp="2okow5if6l34w">
                          <ArrowDownIcon size={14} className="mr-2 text-blue-300" data-id="element-11796" data-mp="2tjs53dya7ti5" />
                          Lowest value
                        </button>
                        <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-11797" data-mp="2yh1rekqdjp1r">
                          <StarIcon size={14} className="mr-2 text-blue-300" data-id="element-11798" data-mp="dsvu01n2ckcf" />
                          Highest score
                        </button>
                      </div>}
                  </div>
                </div>
              </div>
            </div>
            {/* Quotes list */}
            <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10 overflow-hidden" data-id="element-11799" data-mp="24zbj8rv47awl">
              <div className="p-4 border-b border-white/10 flex justify-between items-center" data-id="element-11800" data-mp="2ew6ft57tv188">
                <h3 className="font-semibold text-white flex items-center" data-id="element-11801" data-mp="1r4r78upgjnoj">
                  <FileTextIcon size={18} className="mr-2 text-blue-400" data-id="element-11802" data-mp="1m6ps2kv5k8ic" />
                  {quickFilterActive === 'my-quotes' ? 'My Quotes' : quickFilterActive === 'dealer-quotes' ? "My Dealers' Quotes" : quickFilterActive === 'expired' ? 'Expired Quotes' : quickFilterActive === 'expiring-soon' ? 'Expiring Soon Quotes' : quickFilterActive === 'won-lost' ? 'Won/Lost Quotes' : 'All Quotes'}
                  {appliedFilters.businessUnitUser && <span className="ml-2 text-blue-300" data-id="element-11803" data-mp="13ewv6fcyq35c">
                      • {appliedFilters.businessUnitUser}
                    </span>}
                </h3>
                <div className="flex items-center gap-2" data-id="element-11804" data-mp="y2hrz90kces3">
                  <button className="text-blue-300 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg p-2" data-id="element-11805" data-mp="y42mwzqshzqh">
                    <DownloadIcon size={16} data-id="element-11806" data-mp="jbr2w8qcvtso" />
                  </button>
                  <button className="text-blue-300 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg p-2" data-id="element-11807" data-mp="odgcrl1ue1f6">
                    <PrinterIcon size={16} data-id="element-11808" data-mp="1c3ary99mw22l" />
                  </button>
                  <button className="text-blue-300 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg p-2" data-id="element-11809" data-mp="1h0avacf3mqq0">
                    <RefreshCwIcon size={16} data-id="element-11810" data-mp="123tirhv6b61v" />
                  </button>
                </div>
              </div>
              {viewMode === 'list' && <div className="divide-y divide-white/10" data-id="element-11811" data-mp="3mukc69c3pwh1">
                  {filteredQuotes.map((quote, index) => <div key={index} className="p-4 hover:bg-white/5 transition-colors cursor-pointer" onClick={() => onViewQuote({
                id: quote.id
              })} data-id="element-11812" data-mp="3rtnidx3ti8ql" data-mpi={index}>
                      <div className="flex justify-between items-start" data-id="element-11813" data-mp="3911ih0nwkzrz">
                        <div className="flex items-start" data-id="element-11814" data-mp="342ggowt0681f">
                          <div className="mr-3 mt-0.5" data-id="element-11815" data-mp="2z4ex8aro06pf">
                            <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center" data-id="element-11816" data-mp="2z714saek2m7n">
                              <FileTextIcon size={20} className="text-blue-400" data-id="element-11817" data-mp="2v5ppoytb5jdp" />
                            </div>
                          </div>
                          <div data-id="element-11818" data-mp="3mvkdgr1ip109">
                            <div className="flex items-center" data-id="element-11819" data-mp="3mvaw1rujg266">
                              <h4 className="font-medium text-white" data-id="element-11820" data-mp="3i2r7y0y85on4">
                                {quote.id}
                              </h4>
                              <button className="ml-2 text-blue-300 hover:text-amber-400" onClick={e => {
                          e.stopPropagation();
                          toggleFavorite(quote.id);
                        }} data-id="element-11821" data-mp="3e0efufcehp8t">
                                {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={14} className="fill-amber-500 text-amber-500" data-id="element-11822" data-mp="1scbqdyzvrzfk" /> : <BookmarkIcon size={14} data-id="element-11823" data-mp="1x9278ojiez21" />}
                              </button>
                              {quote.score && <div className={`ml-3 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                          e.stopPropagation();
                          openScoreModal(quote.id, e);
                        }} data-id="element-11824" data-mp="21adx8v6apmar">
                                  <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-11825" data-mp="2g7eqj344xpbc" />
                                  <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-11826" data-mp="2kzy6u7u7iyju">
                                    {quote.score}
                                  </span>
                                </div>}
                            </div>
                            <div className="text-sm text-blue-200 mt-0.5" data-id="element-11827" data-mp="2yyo35l97cu75">
                              {quote.title}
                            </div>
                            <div className="text-xs text-blue-300 mt-1" data-id="element-11828" data-mp="33mmzss9ieud">
                              <span className="flex items-center" data-id="element-11829" data-mp="853nvoaqy1ay">
                                <BuildingIcon size={12} className="mr-1" data-id="element-11830" data-mp="3q9x5pt71yk9d" />
                                {quote.company}
                              </span>
                            </div>
                            <div className="flex items-center mt-2 flex-wrap gap-y-1 gap-x-2" data-id="element-11831" data-mp="mt6rws58b2x4">
                              <span className={`text-xs ${getStatusBadge(quote.status).bg} ${getStatusBadge(quote.status).text} border ${quote.status === 'active' ? 'border-green-800' : quote.status === 'pending' ? 'border-amber-800' : quote.status === 'expired' ? 'border-red-800' : 'border-white/20'} px-2 py-0.5 rounded-full flex items-center`} data-id="element-11832" data-mp="quiiazvxfs6d">
                                {getStatusBadge(quote.status).icon}
                                {quote.status}
                              </span>
                              {quote.tags.map((tag, tagIndex) => {
                          const tagInfo = tags.find(t => t.name === tag);
                          const tagColor = tagInfo ? getTagColor(tagInfo.color) : getTagColor('gray');
                          return <span key={tagIndex} className={`text-xs ${tagColor.bg} ${tagColor.text} ${tagColor.border} px-2 py-0.5 rounded-full`} data-id="element-11833" data-mp="1tlt8hxcies9x" data-mpi={tagIndex}>
                                    {tag}
                                  </span>;
                        })}
                              {quote.businessUnitUser && <span className="text-xs bg-indigo-100 dark:bg-indigo-900/40 text-indigo-800 dark:text-indigo-300 border border-indigo-200 dark:border-indigo-800 px-2 py-0.5 rounded-full flex items-center cursor-pointer" onClick={e => {
                          e.stopPropagation();
                          const user = businessUnitUsers.find(u => u.name === quote.businessUnitUser);
                          if (user) {
                            setSelectedBusinessUnitUser(user);
                            setShowUserModal(true);
                          }
                        }} data-id="element-11834" data-mp="wxwy5a7o0t75">
                                  <UserIcon size={10} className="mr-1" data-id="element-11835" data-mp="2tdf18vbuv2na" />
                                  {quote.businessUnitUser}
                                </span>}
                            </div>
                          </div>
                        </div>
                        <div className="text-right" data-id="element-11836" data-mp="25pxg3in3j2ta">
                          <div className="font-semibold text-white" data-id="element-11837" data-mp="25r8hjbt2jyh8">
                            {quote.amount}
                          </div>
                          <div className="text-xs text-blue-300 mt-1 flex items-center justify-end" data-id="element-11838" data-mp="2fn36eonvypsg">
                            <CalendarIcon size={12} className="mr-1" data-id="element-11839" data-mp="2ketoxhwz8juy" />
                            Created {quote.date}
                          </div>
                          <div className="text-xs text-blue-300 mt-1" data-id="element-11840" data-mp="1mynxmjvcl3pk">
                            {quote.status !== 'approved' && quote.status !== 'expired' ? `Expires in ${quote.expiresIn}` : quote.expiresIn}
                          </div>
                          <div className="mt-2 flex space-x-2 justify-end" data-id="element-11841" data-mp="1fevfo0j2zsz5">
                            <button className="text-blue-200 hover:text-white text-sm font-medium bg-white/10 hover:bg-white/15 rounded-lg px-3 py-1 flex items-center" data-id="element-11842" data-mp="1agbqlr96y12k">
                              <EyeIcon size={14} className="mr-1.5" data-id="element-11843" data-mp="15gz63d5sl635" />
                              View
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>)}
                </div>}
              {viewMode === 'grid' && <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4" data-id="element-11844" data-mp="rq3sjnkcm0t8">
                  {filteredQuotes.map((quote, index) => <div key={index} className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm border border-white/10 rounded-lg overflow-hidden hover:border-blue-500/30 transition-all cursor-pointer shadow-lg" onClick={() => onViewQuote({
                id: quote.id
              })} data-id="element-11845" data-mp="hrmyghq4562y" data-mpi={index}>
                      <div className="p-4" data-id="element-11846" data-mp="17fsctbwimgf5">
                        <div className="flex justify-between items-start mb-3" data-id="element-11847" data-mp="17egyii5g1q9s">
                          <div className="flex items-center" data-id="element-11848" data-mp="tp6txn72a6h9">
                            <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center mr-2" data-id="element-11849" data-mp="tmkk1gwp7evv">
                              <FileTextIcon size={16} className="text-blue-400" data-id="element-11850" data-mp="jqh9pnrp09xu" />
                            </div>
                            <h4 className="font-medium text-white" data-id="element-11851" data-mp="optxqbuavn20">
                              {quote.id}
                            </h4>
                          </div>
                          <div className="flex items-center" data-id="element-11852" data-mp="er4o16ck58wu">
                            {quote.score && <div className={`mr-2 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                        e.stopPropagation();
                        openScoreModal(quote.id, e);
                      }} data-id="element-11853" data-mp="et7bpjq8mpye">
                                <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-11854" data-mp="3tl3q1c7enlo7" />
                                <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-11855" data-mp="3pji6x94a2b5k">
                                  {quote.score}
                                </span>
                              </div>}
                            <button className="text-blue-300 hover:text-amber-400" onClick={e => {
                        e.stopPropagation();
                        toggleFavorite(quote.id);
                      }} data-id="element-11856" data-mp="h5rl3rm1ngzk">
                              {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={12} className="fill-amber-500 text-amber-500" data-id="element-11857" data-mp="q5xy7cdtyey7" /> : <BookmarkIcon size={12} data-id="element-11858" data-mp="l74v8dw666ca" />}
                            </button>
                          </div>
                        </div>
                        <div className="text-sm text-blue-200 mb-2" data-id="element-11859" data-mp="2rzx9hxqycwaw">
                          {quote.title}
                        </div>
                        <div className="text-xs text-blue-300 mb-2" data-id="element-11860" data-mp="qw4uy7iqijbx">
                          <span className="flex items-center" data-id="element-11861" data-mp="vuoey2drpl1n">
                            <BuildingIcon size={12} className="mr-1" data-id="element-11862" data-mp="vv7w3gvlg5em" />
                            {quote.company}
                          </span>
                        </div>
                        <div className="flex flex-wrap gap-1 mb-3" data-id="element-11863" data-mp="14wfip1oqzhsv">
                          {quote.tags.map((tag, tagIndex) => {
                      const tagInfo = tags.find(t => t.name === tag);
                      const tagColor = tagInfo ? getTagColor(tagInfo.color) : getTagColor('gray');
                      return <span key={tagIndex} className={`text-xs ${tagColor.bg} ${tagColor.text} ${tagColor.border} px-2 py-0.5 rounded-full`} data-id="element-11864" data-mp="1jlbpywizcqsf" data-mpi={tagIndex}>
                                {tag}
                              </span>;
                    })}
                          {quote.businessUnitUser && <span className="text-xs bg-indigo-100 dark:bg-indigo-900/40 text-indigo-800 dark:text-indigo-300 border border-indigo-200 dark:border-indigo-800 px-2 py-0.5 rounded-full flex items-center cursor-pointer" onClick={e => {
                      e.stopPropagation();
                      const user = businessUnitUsers.find(u => u.name === quote.businessUnitUser);
                      if (user) {
                        setSelectedBusinessUnitUser(user);
                        setShowUserModal(true);
                      }
                    }} data-id="element-11865" data-mp="1xjievn5ybgfy">
                              <UserIcon size={10} className="mr-1" data-id="element-11866" data-mp="lkt3soutzsv" />
                              {quote.businessUnitUser}
                            </span>}
                        </div>
                        <div className="flex justify-between items-end" data-id="element-11867" data-mp="3rxxc4dzhi0xi">
                          <span className={`text-xs ${getStatusBadge(quote.status).bg} ${getStatusBadge(quote.status).text} border ${quote.status === 'active' ? 'border-green-800' : quote.status === 'pending' ? 'border-amber-800' : quote.status === 'expired' ? 'border-red-800' : 'border-white/20'} px-2 py-0.5 rounded-full flex items-center`} data-id="element-11868" data-mp="3n0npf63hc3dd">
                            {getStatusBadge(quote.status).icon}
                            {quote.status}
                          </span>
                          <div className="font-semibold text-white" data-id="element-11869" data-mp="3e5etydf381ua">
                            {quote.amount}
                          </div>
                        </div>
                      </div>
                      <div className="bg-white/5 p-3 border-t border-white/10 flex justify-between items-center" data-id="element-11870" data-mp="aooktpo7l8od">
                        <div className="text-xs text-blue-300 flex items-center" data-id="element-11871" data-mp="fly8p0vy9ca3">
                          <CalendarIcon size={12} className="mr-1" data-id="element-11872" data-mp="1lx4bbgh7mpv" />
                          {quote.date}
                        </div>
                        <div className="text-xs text-blue-300" data-id="element-11873" data-mp="5q4wjim57ksu">
                          {quote.status !== 'approved' && quote.status !== 'expired' ? `Expires in ${quote.expiresIn}` : quote.expiresIn}
                        </div>
                      </div>
                    </div>)}
                </div>}
              {viewMode === 'kanban' && <div className="p-4 overflow-x-auto" data-id="element-11874" data-mp="2dwf4i5le2r6h">
                  <div className="flex gap-4 min-w-[800px]" data-id="element-11875" data-mp="2dvnlrvcw4nxm">
                    {/* Activas */}
                    <div className="flex-1 min-w-[250px]" data-id="element-11876" data-mp="2ssejm06x1rl4">
                      <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg p-3 mb-3 border border-white/10" data-id="element-11877" data-mp="2nttky57bbfys">
                        <h4 className="text-white font-medium flex items-center" data-id="element-11878" data-mp="202eeq1cf0ei9">
                          <CheckCircleIcon size={16} className="text-green-400 mr-2" data-id="element-11879" data-mp="1v6z37g1vqup0" />
                          Active (
                          {filteredQuotes.filter(q => q.status === 'active').length}
                          )
                        </h4>
                      </div>
                      <div className="space-y-3" data-id="element-11880" data-mp="1hcpwn8tnwskb">
                        {filteredQuotes.filter(q => q.status === 'active').map((quote, index) => <div key={index} className="bg-gradient-to-r from-emerald-500/10 to-teal-500/10 border border-emerald-500/20 rounded-lg p-3 hover:border-emerald-500/40 transition-all cursor-pointer shadow-md" onClick={() => onViewQuote({
                      id: quote.id
                    })} data-id="element-11881" data-mp="1cctulf4izb7e" data-mpi={index}>
                              <div className="flex justify-between items-start mb-2" data-id="element-11882" data-mp="33g6s4mg4aqdg">
                                <h5 className="text-white font-medium" data-id="element-11883" data-mp="2yliyk969b5s0">
                                  {quote.id}
                                </h5>
                                <div className="flex items-center" data-id="element-11884" data-mp="38e87oxec47k6">
                                  {quote.score && <div className={`mr-2 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                            e.stopPropagation();
                            openScoreModal(quote.id, e);
                          }} data-id="element-11885" data-mp="3mdq33vm4yj2i">
                                      <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-11886" data-mp="1nyn48rouhfze" />
                                      <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-11887" data-mp="1duy9ugb90g85">
                                        {quote.score}
                                      </span>
                                    </div>}
                                  <button className="text-blue-300 hover:text-amber-400" onClick={e => {
                            e.stopPropagation();
                            toggleFavorite(quote.id);
                          }} data-id="element-11888" data-mp="1420x6qsxtlhg">
                                    {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={12} className="fill-amber-500 text-amber-500" data-id="element-11889" data-mp="z623qosr5da6" /> : <BookmarkIcon size={12} data-id="element-11890" data-mp="l613nbkba9vr" />}
                                  </button>
                                </div>
                              </div>
                              <div className="text-sm text-blue-200 mb-2" data-id="element-11891" data-mp="2fja6wlm9kz5k">
                                {quote.title}
                              </div>
                              <div className="text-xs text-blue-300 mb-2" data-id="element-11892" data-mp="2khbwzqi3xyqj">
                                {quote.company}
                              </div>
                              <div className="flex justify-between items-center" data-id="element-11893" data-mp="2e1lhcaz6vgiw">
                                <div className="text-xs text-blue-300" data-id="element-11894" data-mp="2928lj0qcaz46">
                                  Expires in {quote.expiresIn}
                                </div>
                                <div className="font-medium text-white" data-id="element-11895" data-mp="2460de7ak866i">
                                  {quote.amount}
                                </div>
                              </div>
                            </div>)}
                      </div>
                    </div>
                    {/* Pendientes */}
                    <div className="flex-1 min-w-[250px]" data-id="element-11896" data-mp="2n2t4bww98uxo">
                      <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg p-3 mb-3 border border-white/10" data-id="element-11897" data-mp="2n29nykm96elr">
                        <h4 className="text-white font-medium flex items-center" data-id="element-11898" data-mp="3frgsq1caw0fg">
                          <ClockIcon size={16} className="text-amber-400 mr-2" data-id="element-11899" data-mp="3n2d55v4n09ux" />
                          Pending (
                          {filteredQuotes.filter(q => q.status === 'pending').length}
                          )
                        </h4>
                      </div>
                      <div className="space-y-3" data-id="element-11900" data-mp="xhve8seebuf">
                        {filteredQuotes.filter(q => q.status === 'pending').map((quote, index) => <div key={index} className="bg-gradient-to-r from-blue-500/10 to-indigo-500/10 border border-blue-500/20 rounded-lg p-3 hover:border-blue-500/40 transition-all cursor-pointer shadow-md" onClick={() => onViewQuote({
                      id: quote.id
                    })} data-id="element-11901" data-mp="9w37pm7a0umr" data-mpi={index}>
                              <div className="flex justify-between items-start mb-2" data-id="element-11902" data-mp="ol96j927ciu4">
                                <h5 className="text-white font-medium" data-id="element-11903" data-mp="tjsrp78z1qlf">
                                  {quote.id}
                                </h5>
                                <div className="flex items-center" data-id="element-11904" data-mp="xlxk62nooh6h">
                                  {quote.score && <div className={`mr-2 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                            e.stopPropagation();
                            openScoreModal(quote.id, e);
                          }} data-id="element-11905" data-mp="1v8ziub06nvoa">
                                      <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-11906" data-mp="201itaz3kqaov" />
                                      <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-11907" data-mp="1cbohmkuzqs67">
                                        {quote.score}
                                      </span>
                                    </div>}
                                  <button className="text-blue-300 hover:text-amber-400" onClick={e => {
                            e.stopPropagation();
                            toggleFavorite(quote.id);
                          }} data-id="element-11908" data-mp="1gci89lztil2s">
                                    {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={12} className="fill-amber-500 text-amber-500" data-id="element-11909" data-mp="2ruj84c3z349s" /> : <BookmarkIcon size={12} data-id="element-11910" data-mp="307mel0uu00fs" />}
                                  </button>
                                </div>
                              </div>
                              <div className="text-sm text-blue-200 mb-2" data-id="element-11911" data-mp="2qc1fbah5de9q">
                                {quote.title}
                              </div>
                              <div className="text-xs text-blue-300 mb-2" data-id="element-11912" data-mp="3izouub3k9epi">
                                {quote.company}
                              </div>
                              <div className="flex justify-between items-center" data-id="element-11913" data-mp="3ny8lgot3neo7">
                                <div className="text-xs text-blue-300" data-id="element-11914" data-mp="398u6902ue30w">
                                  Expires in {quote.expiresIn}
                                </div>
                                <div className="font-medium text-white" data-id="element-11915" data-mp="5sn6h4njspxe">
                                  {quote.amount}
                                </div>
                              </div>
                            </div>)}
                      </div>
                    </div>
                    {/* Por expirar */}
                    <div className="flex-1 min-w-[250px]" data-id="element-11916" data-mp="fhsqk39d8ka9">
                      <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg p-3 mb-3 border border-white/10" data-id="element-11917" data-mp="aho8i8st7hhx">
                        <h4 className="text-white font-medium flex items-center" data-id="element-11918" data-mp="6f1dy04r7ih1">
                          <AlarmClockIcon size={16} className="text-amber-400 mr-2" data-id="element-11919" data-mp="1h9kv2sdhqb9" />
                          Expiring Soon (
                          {filteredQuotes.filter(q => q.status === 'expiring').length}
                          )
                        </h4>
                      </div>
                      <div className="space-y-3" data-id="element-11920" data-mp="3iy98x17dl29f">
                        {filteredQuotes.filter(q => q.status === 'expiring').map((quote, index) => <div key={index} className="bg-gradient-to-r from-amber-500/10 to-orange-500/10 border border-amber-500/20 rounded-lg p-3 hover:border-amber-500/40 transition-all cursor-pointer shadow-md" onClick={() => onViewQuote({
                      id: quote.id
                    })} data-id="element-11921" data-mp="3eul3ao2b0gqt" data-mpi={index}>
                              <div className="flex justify-between items-start mb-2" data-id="element-11922" data-mp="1ucajct8zimo2">
                                <h5 className="text-white font-medium" data-id="element-11923" data-mp="1ygqnoq2y9m16">
                                  {quote.id}
                                </h5>
                                <div className="flex items-center" data-id="element-11924" data-mp="16o9bznnjlca8">
                                  {quote.score && <div className={`mr-2 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                            e.stopPropagation();
                            openScoreModal(quote.id, e);
                          }} data-id="element-11925" data-mp="16mg82g4bd65x">
                                      <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-11926" data-mp="n0jtk71hwodo" />
                                      <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-11927" data-mp="ryv3ehrsiyvw">
                                        {quote.score}
                                      </span>
                                    </div>}
                                  <button className="text-blue-300 hover:text-amber-400" onClick={e => {
                            e.stopPropagation();
                            toggleFavorite(quote.id);
                          }} data-id="element-11928" data-mp="3cjwvj94i3g82">
                                    {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={12} className="fill-amber-500 text-amber-500" data-id="element-11929" data-mp="49v9c2i7va1s" /> : <BookmarkIcon size={12} data-id="element-11930" data-mp="3vhhj8cvj48r3" />}
                                  </button>
                                </div>
                              </div>
                              <div className="text-sm text-blue-200 mb-2" data-id="element-11931" data-mp="e2j5cv1dh9zg">
                                {quote.title}
                              </div>
                              <div className="text-xs text-blue-300 mb-2" data-id="element-11932" data-mp="n2fwr4f5cmy7">
                                {quote.company}
                              </div>
                              <div className="flex justify-between items-center" data-id="element-11933" data-mp="11o3igu0zzzj6">
                                <div className="text-xs text-blue-300" data-id="element-11934" data-mp="11madrk9y3pdt">
                                  Expires in {quote.expiresIn}
                                </div>
                                <div className="font-medium text-white" data-id="element-11935" data-mp="smvlcfa7x4qo">
                                  {quote.amount}
                                </div>
                              </div>
                            </div>)}
                      </div>
                    </div>
                    {/* Aprobadas/Finalizadas */}
                    <div className="flex-1 min-w-[250px]" data-id="element-11936" data-mp="nq5aq7h6n1cn">
                      <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg p-3 mb-3 border border-white/10" data-id="element-11937" data-mp="90qvwjuu7rpv">
                        <h4 className="text-white font-medium flex items-center" data-id="element-11938" data-mp="3w45hgy5ltchh">
                          <CheckIcon size={16} className="text-blue-400 mr-2" data-id="element-11939" data-mp="uf14eovx5d" />
                          Approved (
                          {filteredQuotes.filter(q => q.status === 'approved').length}
                          )
                        </h4>
                      </div>
                      <div className="space-y-3" data-id="element-11940" data-mp="2s32k1q8ucdql">
                        {filteredQuotes.filter(q => q.status === 'approved').map((quote, index) => <div key={index} className="bg-gradient-to-r from-blue-500/10 to-indigo-500/10 border border-blue-500/20 rounded-lg p-3 hover:border-blue-500/40 transition-all cursor-pointer shadow-md" onClick={() => onViewQuote({
                      id: quote.id
                    })} data-id="element-11941" data-mp="320ys296heskh" data-mpi={index}>
                              <div className="flex justify-between items-start mb-2" data-id="element-11942" data-mp="3fsdaadskepqh">
                                <h5 className="text-white font-medium" data-id="element-11943" data-mp="3fupr2nml6u1y">
                                  {quote.id}
                                </h5>
                                <div className="flex items-center" data-id="element-11944" data-mp="3prm518v988dw">
                                  {quote.score && <div className={`mr-2 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                            e.stopPropagation();
                            openScoreModal(quote.id, e);
                          }} data-id="element-11945" data-mp="3uounlakbeefo">
                                      <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-11946" data-mp="194w5ndnr9f8j" />
                                      <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-11947" data-mp="146kvt2xgn4qb">
                                        {quote.score}
                                      </span>
                                    </div>}
                                  <button className="text-blue-300 hover:text-amber-400" onClick={e => {
                            e.stopPropagation();
                            toggleFavorite(quote.id);
                          }} data-id="element-11948" data-mp="1s2yzq6v5u2d7">
                                    {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={12} className="fill-amber-500 text-amber-500" data-id="element-11949" data-mp="2klcprka98k1q" /> : <BookmarkIcon size={12} data-id="element-11950" data-mp="2frrpfll6vdzd" />}
                                  </button>
                                </div>
                              </div>
                              <div className="text-sm text-blue-200 mb-2" data-id="element-11951" data-mp="iudlz8xnmnqu">
                                {quote.title}
                              </div>
                              <div className="text-xs text-blue-300 mb-2" data-id="element-11952" data-mp="433kf7gkg6ks">
                                {quote.company}
                              </div>
                              <div className="flex justify-between items-center" data-id="element-11953" data-mp="3r8uoq14x05qi">
                                <div className="text-xs text-blue-300" data-id="element-11954" data-mp="3vbr8vwa3s9wk">
                                  {quote.expiresIn}
                                </div>
                                <div className="font-medium text-white" data-id="element-11955" data-mp="3he2pksvopatm">
                                  {quote.amount}
                                </div>
                              </div>
                            </div>)}
                      </div>
                    </div>
                    {/* Expiradas */}
                    <div className="flex-1 min-w-[250px]" data-id="element-11956" data-mp="3518otqg3bgec">
                      <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg p-3 mb-3 border border-white/10" data-id="element-11957" data-mp="351rxegjuosfp">
                        <h4 className="text-white font-medium flex items-center" data-id="element-11958" data-mp="3er1rg1y98l6g">
                          <XCircleIcon size={16} className="text-red-400 mr-2" data-id="element-11959" data-mp="3a0lai7v86hfc" />
                          Expired (
                          {filteredQuotes.filter(q => q.status === 'expired').length}
                          )
                        </h4>
                      </div>
                      <div className="space-y-3" data-id="element-11960" data-mp="3iuzrqfzbg213">
                        {filteredQuotes.filter(q => q.status === 'expired').map((quote, index) => <div key={index} className="bg-gradient-to-r from-red-500/10 to-rose-500/10 border border-red-500/20 rounded-lg p-3 hover:border-red-500/40 transition-all cursor-pointer shadow-md" onClick={() => onViewQuote({
                      id: quote.id
                    })} data-id="element-11961" data-mp="3srchj2rqpvqk" data-mpi={index}>
                              <div className="flex justify-between items-start mb-2" data-id="element-11962" data-mp="pgdbfu1axpf2">
                                <h5 className="text-white font-medium" data-id="element-11963" data-mp="uf7u8vz9rdz6">
                                  {quote.id}
                                </h5>
                                <div className="flex items-center" data-id="element-11964" data-mp="zfm0q9l82fv3">
                                  {quote.score && <div className={`mr-2 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                            e.stopPropagation();
                            openScoreModal(quote.id, e);
                          }} data-id="element-11965" data-mp="13euydpjduxvx">
                                      <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-11966" data-mp="foquri672y4x" />
                                      <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-11967" data-mp="kibi8ga5w9pv">
                                        {quote.score}
                                      </span>
                                    </div>}
                                  <button className="text-blue-300 hover:text-amber-400" onClick={e => {
                            e.stopPropagation();
                            toggleFavorite(quote.id);
                          }} data-id="element-11968" data-mp="3gmcb02ph6nc0">
                                    {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={12} className="fill-amber-500 text-amber-500" data-id="element-11969" data-mp="37nqyao6oq2j5" /> : <BookmarkIcon size={12} data-id="element-11970" data-mp="32mbbaqky5ly4" />}
                                  </button>
                                </div>
                              </div>
                              <div className="text-sm text-blue-200 mb-2" data-id="element-11971" data-mp="2svyu98cccawq">
                                {quote.title}
                              </div>
                              <div className="text-xs text-blue-300 mb-2" data-id="element-11972" data-mp="2nvkndtmh770a">
                                {quote.company}
                              </div>
                              <div className="flex justify-between items-center" data-id="element-11973" data-mp="2evxkf3e3lt54">
                                <div className="text-xs text-red-400" data-id="element-11974" data-mp="29z71m8awsjg0">
                                  {quote.expiresIn}
                                </div>
                                <div className="font-medium text-white" data-id="element-11975" data-mp="259mvaq8x71zx">
                                  {quote.amount}
                                </div>
                              </div>
                            </div>)}
                      </div>
                    </div>
                  </div>
                </div>}
              {/* Pagination */}
              <div className="p-4 border-t border-white/10 flex justify-between items-center" data-id="element-11976" data-mp="2j2cj9080egzo">
                <div className="text-sm text-blue-300" data-id="element-11977" data-mp="2nyt67r3h2pb6">
                  Showing{' '}
                  <span className="font-medium text-white" data-id="element-11978" data-mp="29a6s1spl03lj">
                    {filteredQuotes.length}
                  </span>{' '}
                  quotes
                </div>
                <div className="flex items-center space-x-1" data-id="element-11979" data-mp="31zdmoglx091i">
                  <button className="px-3 py-1.5 text-blue-200 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg" data-id="element-11980" data-mp="31y2k2k47h7bz">
                    Previous
                  </button>
                  <button className="px-3 py-1.5 text-white bg-blue-600 rounded-lg" data-id="element-11981" data-mp="v9sgh56oibmg">
                    1
                  </button>
                  <button className="px-3 py-1.5 text-blue-200 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg" data-id="element-11982" data-mp="151gc7ia9qetq">
                    2
                  </button>
                  <button className="px-3 py-1.5 text-blue-200 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg" data-id="element-11983" data-mp="103517488ly9x">
                    3
                  </button>
                  <button className="px-3 py-1.5 text-blue-200 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg" data-id="element-11984" data-mp="7ezien0qujcq">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Quote Score Modal */}
      {showScoreModal && selectedScore && <QuoteScoreModal quote={quotesList.find(q => q.id === selectedScore)} onClose={() => setShowScoreModal(false)} onUpdate={(quoteId, scoreDetails) => {
      // Actualizar la puntuación en la cotización seleccionada
      const updatedQuotes = quotesList.map(q => q.id === quoteId ? {
        ...q,
        scoreDetails,
        score: scoreDetails.totalScore
      } : q);
      // Aquí debería actualizar el estado de las cotizaciones
      // setQuotes(updatedQuotes);
    }} data-id="element-11985" data-mp="1wugtd1y53kht" />}
      {/* Business Unit User Modal */}
      {showUserModal && selectedBusinessUnitUser && <BusinessUnitUserModal user={selectedBusinessUnitUser} onClose={() => setShowUserModal(false)} data-id="element-11986" data-mp="8ubnacqofdin" />}
    </div>;
}
// LogoutIcon component for the user menu
function LogoutIcon({
  size,
  className
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-11987" data-mp="itsq8mejndax">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" data-id="element-11988" data-mp="2kmh0hfplv107" />
      <polyline points="16 17 21 12 16 7" data-id="element-11989" data-mp="2pkif9og00e5v" />
      <line x1="21" y1="12" x2="9" y2="12" data-id="element-11990" data-mp="2pll9a58mawq0" />
    </svg>;
}